import { render } from "./EditConfigClassifications.vue?vue&type=template&id=088c0f0b"
import script from "./EditConfigClassifications.vue?vue&type=script&lang=js"
export * from "./EditConfigClassifications.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__